import { useIntl } from "react-intl";
import { WmButton } from "@watermarkinsights/ripple-react";
import { buildSvgIconHref } from "../ai-chat-message-utils";
import { MessageExportMenu } from "./MessageExportMenu";

interface AssistantMessageActionsProps {
  isCopied: boolean;
  onCopyResponseText: () => void;
  onExportPdf: () => void;
  onExportText: () => void;
  isExportingPdf: boolean;
  exportError: string | null;
}

export const AssistantMessageActions = ({
  isCopied,
  onCopyResponseText,
  onExportPdf,
  onExportText,
  isExportingPdf,
  exportError,
}: AssistantMessageActionsProps) => {
  const intl = useIntl();

  return (
    <div className="tcw-response-actions">
      <div className="tcw-action-group">
        <WmButton
          button-type="navigational"
          icon={buildSvgIconHref("copy")}
          className="tcw-action-btn"
          tooltip={intl.formatMessage({ id: "app.toolboxChat.action.copyResponse" })}
          onClick={onCopyResponseText}
        />
        <MessageExportMenu
          onExportPdf={onExportPdf}
          onExportText={onExportText}
          disabled={isExportingPdf}
        />
        {isCopied && (
          <span className="tcw-copied" role="status">
            {intl.formatMessage({ id: "app.toolboxChat.action.copied" })}
          </span>
        )}
        {exportError && (
          <span className="tcw-copied" role="status">
            {exportError}
          </span>
        )}
      </div>
    </div>
  );
};
